import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Blue_White_Gradient_Btn.css";

const Blue_White_Gradient_Btn = (props) => {
  return (
    <button
      className={`premium-blue-btn ${props.className || ""}`}
      onClick={props?.onClick}
      type={props?.type || "button"}
      disabled={props?.disabled}
    >
      {props?.icon && (
        <div className="btn-icon-wrapper">
          <FontAwesomeIcon icon={props.icon} className="btn-icon" />
        </div>
      )}
      <span className="btn-text">{props?.btn_name}</span>
    </button>
  );
};

export default Blue_White_Gradient_Btn;